/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import Lottie from "lottie-react";
// import { LazyLoadImage } from "react-lazy-load-image-component";
export function IconController({ src, className }) {
  return (
    <div className={className}>
      <img src={src} className="w-full h-full" alt="" />
    </div>
  );
}
export function LottieController({ src, className }) {
  return (
    <div className={className}>
      <Lottie animationData={src} loop={true} />
    </div>
  );
}
export function ImgController({
  src,
  style,
  className,
  imgClassName,
  size = "",
}) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={className}>
      {loaded ? (
        <img
          src={
            size === ""
              ? src
              : src.replace(
                  "https://d15xdsbb8need2.cloudfront.net",
                  `https://df569pv1v84fo.cloudfront.net/fit-in/${size}x${size}`
                )
          }
          className={`w-full h-full block ${imgClassName}`}
          alt="Img"
          style={style}
          onLoad={() => {
            setLoaded(true);
          }}
        />
      ) : (
        <>
          <Skeleton
            className={`w-full h-full ${imgClassName}`}
            circle={imgClassName === "rounded-full" ? true : false}
          />
          <img
            src={src}
            className={`hidden`}
            onLoad={() => {
              setLoaded(true);
            }}
          />
        </>
      )}
    </div>
  );
}
export function MostCardImage({ newRequest, src, bColor }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [newRequest]);

  const handleImageLoad = () => {
    setLoaded(true);
  };

  return (
    <>
      {loaded ? (
        <div
          className={`rounded-full img-border h-full`}
          style={{ borderColor: "#" + bColor }}
        >
          <img src={src} className={`w-full h-full rounded-full`} alt="Load" />
        </div>
      ) : (
        <>
          <Skeleton className="w-full h-full rounded-full" circle="true" />
          <img src={src} alt="" className="hidden" onLoad={handleImageLoad} />
        </>
      )}
    </>
  );
}
